import styled from 'styled-components'
import BaseModal from 'sidecar-ui/lib/Modal' 

export const Modal = styled(BaseModal)`
  width: 42rem;
`

export const Message = styled.h3`
  font-size: 18px;
  line-height: 25px;
  font-family: 'apercu-bold-pro', sans-serif;
  color: black;
  margin-bottom: 20px;
`



// WEBPACK FOOTER //
// ./src/modals/AutoLogoutModal/styles.js